import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
    ...enLocale,
    refresh: 'refresh',
    Save_cmd: 'Save',
    Close_cmd: 'Close',
    Del_cmd: 'Delete',
    Query_cmd: 'Query',
    Send_cmd: 'Send',
    Submit_cmd: 'Submit',
    Sign_in: 'Sign in',
    Sign_Out: 'Sign out',
    Confirm_txt: 'OK',
    Load_txt: 'Loading',
    Error_txt: 'Error',
    Success_txt: 'Success',
    Warning_txt: 'Warning',
    Info_txt: 'Info',
    Upload_txt: 'Upload',
    Anno_txt: 'Announcements',
    Report_txt: 'Report',
    Excel_txt: 'Excel',
    Preview_txt: 'Preview',
    NextPage_txt: 'Next',
};

export default en;